export default __webpack_public_path__ + "static/media/hub.d56ce993.svg";